module.exports = __webpack_public_path__ + "static/media/email.e9faa9d7.svg";